// extracted by mini-css-extract-plugin
export var listTalks = "talks-section-module--listTalks--4995a";
export var logo = "talks-section-module--logo--d7b04";
export var section = "talks-section-module--section--52967";
export var talkHeader = "talks-section-module--talkHeader--b35d1";